import React from "react";
import { observer } from "mobx-react";
import { AuthorCollectingSocietyCreateStore } from "../../store";
import { AuthorCollectingSocietyCreateForm } from "./AuthorCollectingSocietyCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AuthorCollectingSocietyCreateProps = {
  authorCollectingSocietyCreateStore: AuthorCollectingSocietyCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AuthorCollectingSocietyCreate: React.FC<AuthorCollectingSocietyCreateProps> =
  observer(
    ({
      authorCollectingSocietyCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={authorCollectingSocietyCreateStore.isSaving} />
          <AuthorCollectingSocietyCreateForm
            authorCollectingSocietyCreateStore={
              authorCollectingSocietyCreateStore
            }
            collectingSocietyError={
              authorCollectingSocietyCreateStore.errors.collectingSociety
                ?.message
            }
            onCollectingSocietyChange={(value) => {
              authorCollectingSocietyCreateStore.setCollectingSocietyValue(
                value
              );
            }}
            collectingSocietySelectedValue={
              authorCollectingSocietyCreateStore.entityValues
                .showCollectingSociety
            }
            onCollectingSocietySelected={(value) => {
              authorCollectingSocietyCreateStore.setSelectedCollectingSociety(
                value
              );
            }}
            collectingSocietyOptions={authorCollectingSocietyCreateStore.getCollectingSocietyOptions()}
            memberNumberError={
              authorCollectingSocietyCreateStore.errors.memberNumber?.message
            }
            onMemberNumberChange={(value: string) => {
              authorCollectingSocietyCreateStore.setMemberNumberValue(value);
            }}
            memberNumber={
              authorCollectingSocietyCreateStore.entityValues.memberNumber
            }
            territoriesError={
              authorCollectingSocietyCreateStore.errors.territories?.message
            }
            onTerritoriesChange={(value) => {
              authorCollectingSocietyCreateStore.setTerritoriesValue(value);
            }}
            territoriesSelectedValues={
              authorCollectingSocietyCreateStore.entityValues.showTerritories
            }
            onTerritoriesSelected={(value) => {
              authorCollectingSocietyCreateStore.setSelectedTerritories(value);
            }}
            territoriesOptions={authorCollectingSocietyCreateStore.getTerritoriesOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={authorCollectingSocietyCreateStore.isProcessing}
            onSave={() =>
              authorCollectingSocietyCreateStore.saveNewAuthorCollectingSociety()
            }
            onCancel={() =>
              authorCollectingSocietyCreateStore.cancelNewAuthorCollectingSociety()
            }
          />
          <ErrorDialog
            open={authorCollectingSocietyCreateStore.errorDialogOpened}
            title={authorCollectingSocietyCreateStore.errorTitle}
            description={authorCollectingSocietyCreateStore.errorDescription}
            onClose={() =>
              authorCollectingSocietyCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
